import { useFakedUID } from "./useFakeUID";
import useFirebaseData from "./useFirebaseData";
import type { Kiln } from "../types";

const useFirebaseKiln = (kiln_id: string) => {
  const uid = useFakedUID();
  return useFirebaseData<Kiln>(uid && kiln_id ? `/userdata/${uid}/kilns/${kiln_id}` : null);
};

export default useFirebaseKiln;
